import React from 'react'
import { IoAddSharp } from 'react-icons/io5'
import { RiErrorWarningLine } from 'react-icons/ri'
import { Link } from 'react-router-dom'

export const NoAccountWarning = () => {
  return (
    <div className='flex flex-col gap-2'>
      <div className='px-4 py-2 w-[300px] rounded-lg border border-red-600'>
        <div className='flex items-center gap-1'>
          <RiErrorWarningLine className='text-red-600' />
          <p className='text-red-600 text-sm'>No bank account found!</p>
        </div>
      </div>

      <Link to='/app/account/payment-details' className='mt-2'>
        <button className='transition-all duration-200 flex items-center gap-2 rounded-full px-4 py-2 bg-white/90 hover:bg-white hover:text-black text-sm'>
          <span>
            <IoAddSharp className='text-lg text-black' />
          </span>{' '}
          Add new account
        </button>
      </Link>
    </div>
  )
}
